/**
 * ============================================================================
 * HEADER MOBILE BTG — Bike To Go Floripa
 * ============================================================================
 * Versão: 1.0.0
 *
 * FUNCIONALIDADES:
 * - Gaveta lateral com overlay e trava de scroll
 * - Hambúrguer → X animado
 * - Submenus accordion
 * - Sticky header
 * - Fechar com Escape e clique fora
 * - Acessibilidade (focus trap, aria)
 * ============================================================================
 */

(function () {
  'use strict';

  class HeaderBTGMobile {
    constructor() {
      this.section   = document.querySelector('.header-btg-mobile-section');
      this.bar       = document.querySelector('.btgm-bar');
      this.drawer    = document.querySelector('.btgm-drawer');
      this.overlay   = document.querySelector('.btgm-overlay');
      this.hamburger = document.querySelector('.btgm-btn--hamburger');
      this.closeBtn  = document.querySelector('.btgm-drawer__close');
      this.submenuItems = document.querySelectorAll('.btgm-nav__item--has-sub');

      if (!this.bar) return;

      this.isOpen       = false;
      this.lastScrollY  = 0;
      this.ticking      = false;
      this.stickyActive = false;
      this.threshold    = parseInt(this.bar.dataset.stickyThreshold) || 80;

      this.init();
    }

    init() {
      // Gaveta
      if (this.hamburger) {
        this.hamburger.addEventListener('click', () => this.openDrawer());
      }
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.closeDrawer());
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.closeDrawer());
      }

      // Submenus accordion
      this.submenuItems.forEach(item => {
        const link = item.querySelector('.btgm-nav__link');
        if (!link) return;
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggleSubmenu(item);
        });
      });

      // Fechar com Escape
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) this.closeDrawer();
      });

      // Sticky
      if (this.bar.dataset.sticky !== 'false') {
        this.setupSticky();
      }

      console.log('[HeaderBTGMobile] Inicializado');
    }

    // ─── GAVETA ─────────────────────────────────────────────────────────────

    openDrawer() {
      this.isOpen = true;

      this.drawer?.classList.add('is-open');
      this.overlay?.classList.add('is-visible');
      this.hamburger?.classList.add('is-open');

      document.body.classList.add('btgm-drawer-open');

      this.hamburger?.setAttribute('aria-expanded', 'true');
      this.drawer?.setAttribute('aria-hidden', 'false');

      // Foco no primeiro item focável da gaveta
      requestAnimationFrame(() => {
        const first = this.drawer?.querySelector(
          'button, [href], input, [tabindex]:not([tabindex="-1"])'
        );
        first?.focus();
      });

      document.dispatchEvent(new CustomEvent('btgm:drawer:open'));
    }

    closeDrawer() {
      this.isOpen = false;

      this.drawer?.classList.remove('is-open');
      this.overlay?.classList.remove('is-visible');
      this.hamburger?.classList.remove('is-open');

      document.body.classList.remove('btgm-drawer-open');

      this.hamburger?.setAttribute('aria-expanded', 'false');
      this.drawer?.setAttribute('aria-hidden', 'true');

      // Devolver foco ao hambúrguer
      this.hamburger?.focus();

      document.dispatchEvent(new CustomEvent('btgm:drawer:close'));
    }

    // ─── SUBMENU ACCORDION ───────────────────────────────────────────────────

    toggleSubmenu(item) {
      const isOpen = item.classList.contains('is-open');

      // Fechar todos os outros
      this.submenuItems.forEach(i => {
        if (i !== item) {
          i.classList.remove('is-open');
          i.querySelector('.btgm-nav__link')?.setAttribute('aria-expanded', 'false');
        }
      });

      // Toggle este
      item.classList.toggle('is-open', !isOpen);
      item.querySelector('.btgm-nav__link')
          ?.setAttribute('aria-expanded', String(!isOpen));
    }

    // ─── STICKY ─────────────────────────────────────────────────────────────

    setupSticky() {
      window.addEventListener('scroll', () => {
        if (!this.ticking) {
          requestAnimationFrame(() => {
            this.handleScroll();
            this.ticking = false;
          });
          this.ticking = true;
        }
      }, { passive: true });

      this.handleScroll();
    }

    handleScroll() {
      const scrollY = window.scrollY;
      const shouldStick = scrollY > this.threshold;

      if (shouldStick !== this.stickyActive) {
        this.stickyActive = shouldStick;

        if (shouldStick) {
          this.bar.classList.add('is-sticky');
          document.body.classList.add('btgm-sticky-active');
          document.documentElement.style.setProperty(
            '--btgm-bar-height',
            `${this.bar.offsetHeight}px`
          );
        } else {
          this.bar.classList.remove('is-sticky');
          document.body.classList.remove('btgm-sticky-active');
        }
      }

      this.lastScrollY = scrollY;
    }
  }

  // ─── Inicializar ──────────────────────────────────────────────────────────

  function init() {
    if (document.querySelector('.btgm-bar')) {
      new HeaderBTGMobile();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.HeaderBTGMobile = HeaderBTGMobile;

})();
